/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 21H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 3L21 8M16 3L11 8M16 3V14.6C16 16.8402 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H9.5H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M16 3L21 8M16 3L11 8M16 3C16 5.80745 16 10.6469 16 14.6012C16 16.8406 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M16 3L21 8M16 3L11 8M16 3C16 5.80745 16 10.6469 16 14.6012C16 16.8406 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 8L18.5 5.5M11 8L16 3C16 5.80745 16 10.6469 16 14.6012C16 16.8406 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 3L21 8M16 3L11 8M16 3C16 5.80745 16 10.6469 16 14.6012C16 16.8406 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M16 3L21 8M16 3L11 8M16 3C16 5.80745 16 10.6469 16 14.6012C16 16.8406 16 17.9603 15.564 18.816C15.1805 19.5686 14.5686 20.1805 13.816 20.564C12.9603 21 11.8402 21 9.6 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
